import * as Yup from 'yup'

import { TEXTFIELD_REQUIRED_LENGTH } from '~/common/constants'

export const RendOTPSchema = (t) =>
  Yup.object().shape({
    code: Yup.string()
      .required(t('form.required'))
      .max(
        TEXTFIELD_REQUIRED_LENGTH.CODE_6.MAX,
        t('form.maxLength', {
          max: TEXTFIELD_REQUIRED_LENGTH.CODE_6.MAX,
        }),
      ),
  })
